export default "__VITE_ASSET__CLKVxDf1__"